"use strict";

var _regeneratorRuntime = require("/usr/src/app/www/node_modules/@babel/runtime/regenerator/index.js");

var _toConsumableArray = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/toConsumableArray.js");

var _asyncToGenerator = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assert = exports.check = void 0;

var Stream_1 = require("../../stream/Stream");

var GlobalParameters_1 = require("./configuration/GlobalParameters");

var QualifiedParameters_1 = require("./configuration/QualifiedParameters");

var DecorateProperty_1 = require("./DecorateProperty");

var RunnerIterator_1 = require("./RunnerIterator");

var SourceValuesIterator_1 = require("./SourceValuesIterator");

var Tosser_1 = require("./Tosser");

var PathWalker_1 = require("./utils/PathWalker");

var RunDetailsFormatter_1 = require("./utils/RunDetailsFormatter");

function runIt(property, shrink, sourceValues, verbose, interruptedAsFailure) {
  var runner = new RunnerIterator_1.RunnerIterator(sourceValues, shrink, verbose, interruptedAsFailure);

  var _iterator = _createForOfIteratorHelper(runner),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var v = _step.value;
      var out = property.run(v);
      runner.handleResult(out);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return runner.runExecution;
}

function asyncRunIt(_x, _x2, _x3, _x4, _x5) {
  return _asyncRunIt.apply(this, arguments);
}

function _asyncRunIt() {
  _asyncRunIt = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(property, shrink, sourceValues, verbose, interruptedAsFailure) {
    var runner, _iterator2, _step2, v, out;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            runner = new RunnerIterator_1.RunnerIterator(sourceValues, shrink, verbose, interruptedAsFailure);
            _iterator2 = _createForOfIteratorHelper(runner);
            _context.prev = 2;

            _iterator2.s();

          case 4:
            if ((_step2 = _iterator2.n()).done) {
              _context.next = 12;
              break;
            }

            v = _step2.value;
            _context.next = 8;
            return property.run(v);

          case 8:
            out = _context.sent;
            runner.handleResult(out);

          case 10:
            _context.next = 4;
            break;

          case 12:
            _context.next = 17;
            break;

          case 14:
            _context.prev = 14;
            _context.t0 = _context["catch"](2);

            _iterator2.e(_context.t0);

          case 17:
            _context.prev = 17;

            _iterator2.f();

            return _context.finish(17);

          case 20:
            return _context.abrupt("return", runner.runExecution);

          case 21:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 14, 17, 20]]);
  }));
  return _asyncRunIt.apply(this, arguments);
}

function runnerPathWalker(valueProducers, shrink, path) {
  var pathPoints = path.split(':');
  var pathStream = (0, Stream_1.stream)(valueProducers).drop(pathPoints.length > 0 ? +pathPoints[0] : 0).map(function (producer) {
    return producer();
  });
  var adaptedPath = ['0'].concat(_toConsumableArray(pathPoints.slice(1))).join(':');
  return (0, Stream_1.stream)((0, PathWalker_1.pathWalk)(adaptedPath, pathStream, shrink)).map(function (v) {
    return function () {
      return v;
    };
  });
}

function buildInitialValues(valueProducers, shrink, qParams) {
  if (qParams.path.length === 0) {
    return (0, Stream_1.stream)(valueProducers);
  }

  return runnerPathWalker(valueProducers, shrink, qParams.path);
}

function check(rawProperty, params) {
  if (rawProperty == null || rawProperty.generate == null) throw new Error('Invalid property encountered, please use a valid property');
  if (rawProperty.run == null) throw new Error('Invalid property encountered, please use a valid property not an arbitrary');
  var qParams = QualifiedParameters_1.QualifiedParameters.read(Object.assign(Object.assign({}, (0, GlobalParameters_1.readConfigureGlobal)()), params));
  if (qParams.reporter !== null && qParams.asyncReporter !== null) throw new Error('Invalid parameters encountered, reporter and asyncReporter cannot be specified together');
  if (qParams.asyncReporter !== null && !rawProperty.isAsync()) throw new Error('Invalid parameters encountered, only asyncProperty can be used when asyncReporter specified');
  var property = (0, DecorateProperty_1.decorateProperty)(rawProperty, qParams);
  var generator = (0, Tosser_1.toss)(property, qParams.seed, qParams.randomType, qParams.examples);
  var maxInitialIterations = qParams.path.indexOf(':') === -1 ? qParams.numRuns : -1;
  var maxSkips = qParams.numRuns * qParams.maxSkipsPerRun;
  var shrink = property.shrink.bind(property);
  var initialValues = buildInitialValues(generator, shrink, qParams);
  var sourceValues = new SourceValuesIterator_1.SourceValuesIterator(initialValues, maxInitialIterations, maxSkips);
  var finalShrink = !qParams.endOnFailure ? shrink : Stream_1.Stream.nil;
  return property.isAsync() ? asyncRunIt(property, finalShrink, sourceValues, qParams.verbose, qParams.markInterruptAsFailure).then(function (e) {
    return e.toRunDetails(qParams.seed, qParams.path, maxSkips, qParams);
  }) : runIt(property, finalShrink, sourceValues, qParams.verbose, qParams.markInterruptAsFailure).toRunDetails(qParams.seed, qParams.path, maxSkips, qParams);
}

exports.check = check;

function assert(property, params) {
  var out = check(property, params);
  if (property.isAsync()) return out.then(RunDetailsFormatter_1.asyncReportRunDetails);else (0, RunDetailsFormatter_1.reportRunDetails)(out);
}

exports.assert = assert;